export const SMART_ACTIONS_COLUMN_SIZE = {
  DESCRIPTION: 700,
  NAME: 300,
} as const;
